export enum DocumentStatus {
  Signable = "SIGNABLE",
  NeedsAttention = "Needs Attention",
  Voided = "VOIDED",
  Ready = "Ready"
}
